export const isPhoneRequiredFromSplit = (
	treatment: string,
	phoneRequirementValue: 'required' | 'optional',
): boolean => {
	if (treatment === 'override' && phoneRequirementValue) {
		return phoneRequirementValue === 'required';
	}

	return true;
};
